import {
  AllergyCategoryEnum,
  AllergySeverityEnum,
  AllergyCriticalityEnum,
  AllergyStatusEnum,
} from "../../Types/Enums/AllergyEnum";
import { 
  GiChickenLeg, 
  GiPill, 
  GiTreeBranch, 
  GiVirus, 
  GiBiohazard, 
  GiShield 
} from 'react-icons/gi';
import type { IconType } from 'react-icons';

export const getCategoryIconComponent = (category: AllergyCategoryEnum | number): IconType => {
  switch (category) {
    case AllergyCategoryEnum.FOOD:
      return GiChickenLeg;
    case AllergyCategoryEnum.MEDICATION:
      return GiPill;
    case AllergyCategoryEnum.ENVIRONMENT:
      return GiTreeBranch;
    case AllergyCategoryEnum.BIOLOGIC:
      return GiVirus;
    case AllergyCategoryEnum.OTHER:
    default:
      return GiBiohazard;
  }
};

export const getSeverityDotColor = (severity: AllergySeverityEnum | number): string => {
  switch (severity) {
    case AllergySeverityEnum.MILD:
      return "#198754"; // Success Green
    case AllergySeverityEnum.MODERATE:
      return "#ffc107"; // Warning Yellow
    case AllergySeverityEnum.SEVERE:
      return "#dc3545"; // Danger Red
    case AllergySeverityEnum.UNSPECIFIED:
    default:
      return "#6c757d"; // Secondary Gray
  }
};

export const getCriticalityDotColor = (criticality: AllergyCriticalityEnum | number): string => {
  switch (criticality) {
    case AllergyCriticalityEnum.LOW:
      return "#0d6efd"; // Info Blue
    case AllergyCriticalityEnum.HIGH:
      return "#d63384"; // Critical Pink/Red
    case AllergyCriticalityEnum.UNABLE_TO_ASSESS:
    case AllergyCriticalityEnum.UNSPECIFIED:
    default:
      return "#6c757d";
  }
};

export const getStatusBadgeVariant = (status: AllergyStatusEnum | number): string => {
  switch (status) {
    case AllergyStatusEnum.ACTIVE:
      return "danger";
    case AllergyStatusEnum.INACTIVE:
      return "secondary";
    case AllergyStatusEnum.RESOLVED:
      return "success";
    case AllergyStatusEnum.REFUTED:
      return "dark";
    default:
      return "light";
  }
};

export const getStatusDotColor = (status: AllergyStatusEnum | number): string => {
  switch (status) {
    case AllergyStatusEnum.ACTIVE:
      return "#dc3545"; // Red
    case AllergyStatusEnum.INACTIVE:
      return "#6c757d"; // Gray
    case AllergyStatusEnum.RESOLVED:
      return "#198754"; // Green
    case AllergyStatusEnum.REFUTED:
      return "#212529"; // Dark / Black
    default:
      return "#adb5bd";
  }
};